"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _selPlat = _interopRequireDefault(require("@/components/selPlat"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
var _index = require("@/utils/index");
var _editwith = _interopRequireDefault(require("@/views/agent/_editwith.vue"));
var _reportContent = require("@/utils/reportContent");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 【操作埋点】2026-05-25 推广员列表相关上报
 */
var _default = exports.default = {
  name: 'AdminList',
  components: {
    editwith: _editwith.default,
    Pagination: _Pagination.default,
    // eslint-disable-next-line vue/no-unused-components
    selPlat: _selPlat.default,
    // eslint-disable-next-line vue/no-unused-components
    drawer: _filter.default
  },
  data: function data() {
    return {
      adminId: '',
      permissionMenu: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      checkedKeys: [],
      dealPhone: _index.dealPhone,
      form: {},
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        start: 1,
        total: 10,
        page_num: 1,
        limit: 20
      },
      permissionDialog: false,
      permissionMinDialog: false,
      addAdminDialog: false,
      isFrozenObj: {},
      isFrozenDialog: false,
      adminInfo: {
        nick_name: '',
        user_name: '',
        phone: '',
        email: '',
        password: '',
        admin_type: 2,
        add_source: 1,
        roles: ''
      },
      rolesName: [{
        'value': 'general',
        'name': '普通管理员'
      }, {
        'value': 'super',
        'name': '超级管理员'
      }]
    };
  },
  computed: {
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    },
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    }
  },
  mounted: function mounted(options) {
    this.getList();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this = this;
      // eslint-disable-next-line prefer-const
      var listQuery = Object.assign({}, this.form, this.listQuery, {
        start: this.listQuery.start - 1
      });
      var url = 'agentapi/promoter_index';
      this.$get(url, listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data;
        _this.listQuery.page_num = res.page_num;
        if (listQuery.start === 0) _this.tableMaxH = window.innerHeight - _this.$refs.order_table.$el.offsetTop - 80;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    toEdit: function toEdit(row, rows) {
      var _this2 = this;
      switch (row.type) {
        case 1:
          this.$get('agentapi/admin/getFrozen', {
            admin_id: row.id
          }).then(function (res) {
            _this2.isFrozenDialog = true;
            _this2.isFrozenObj = res;
          });
          break;
        case 2:
          this.$prompt('请输入新登录密码', '重置登录密码', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'password',
            beforeClose: function beforeClose(action, instance, done) {
              if (action == 'confirm') {
                var value = instance.inputValue;
                // 【操作埋点】2026-05-25 pc_agent_password_1 重置登录密码
                _this2.$post('agentapi/edit_agent_password', {
                  son_id: row.id,
                  password: value
                }, {
                  operation_option: '重置登录密码',
                  content: "\u91CD\u7F6E\u4EE3\u7406".concat((0, _reportContent.buildSubjectPrefix)(row.name, row.id, ''), " \u7684\u767B\u5F55\u5BC6\u7801"),
                  operation_id: 'pc_agent_password_1'
                }).then(function (res) {
                  _this2.$message({
                    message: '设置成功',
                    type: 'success'
                  });
                  done();
                });
              } else {
                done();
              }
            }
          });
          break;
        case 3:
          this.$prompt('请输入新提现密码', '重置提现密码', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'password',
            beforeClose: function beforeClose(action, instance, done) {
              if (action == 'confirm') {
                var value = instance.inputValue;
                // 【操作埋点】2026-05-25 pc_agent_password_1 重置提现密码
                _this2.$post('agentapi/edit_agent_password', {
                  son_id: row.id,
                  password: value,
                  type: 1
                }, {
                  operation_option: '重置提现密码',
                  content: "\u91CD\u7F6E\u4EE3\u7406".concat((0, _reportContent.buildSubjectPrefix)(row.name, row.id, ''), " \u7684\u63D0\u73B0\u5BC6\u7801"),
                  operation_id: 'pc_agent_password_1'
                }).then(function (res) {
                  _this2.$message({
                    message: '设置成功',
                    type: 'success'
                  });
                  done();
                });
              } else {
                done();
              }
            }
          });
          break;
      }
    },
    setIsFrozen: function setIsFrozen() {
      var _this3 = this;
      // 【操作埋点】2026-05-25 pc_agent_frozen_1 账号冻结/优惠设置
      this.$post('agentapi/admin/setFrozen', {
        admin_id: this.isFrozenObj.admin_id,
        is_frozen: this.isFrozenObj.is_frozen,
        is_use_cheap: this.isFrozenObj.is_use_cheap
      }, {
        operation_option: '账号设置',
        content: (0, _reportContent.buildReportContent)(this.isFrozenObj, _reportContent.AGENT_FROZEN_LABELS, {
          prefix: "\u4EE3\u7406\u5546ID ".concat(this.isFrozenObj.admin_id),
          formatters: {
            is_frozen: _reportContent.formatYesNo,
            is_use_cheap: _reportContent.formatYesNo
          }
        }),
        operation_id: 'pc_agent_frozen_1'
      }).then(function (res) {
        _this3.$message({
          message: '设置成功',
          type: 'success'
        });
        _this3.isFrozenDialog = false;
      });
    }
  }
};